// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-result__container>div:not(:first-child){padding-top:32px;border-top:1px solid #707070}.search-result__logo{margin-bottom:20px}.search-result__logo img{max-height:50px;width:auto}.search-result__job-item{display:block;margin-bottom:32px}.search-result__job-item--company{font-weight:500}.search-result__job-item--location{font-size:16px;font-family:OpenSans}", ""]);
// Exports
module.exports = exports;
